import React from 'react'
import ProfileForm from './profileForm';
import * as adminActions from '../actions/admin';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';


class ProfilePage extends React.Component {

  constructor(props) {
    super(props);
    // set the initial component state
    this.state = {
      userLocation: Object.assign({}, this.props.userLocation),
      selectedLocation: Object.assign({}, this.props.selectedLocation)
    };

    this.updateValue = this.updateValue.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

  }

  // componentWillReceiveProps(nextProps) {
  //   if(nextProps.selectedLocation !== this.props.selectedLocation) {
  //       this.setState({
  //         userLocation: Object.assign({}, nextProps.userLocation),
  //         selectedLocation: Object.assign({}, nextProps.selectedLocation)
  //       });
  //   }
  // }

  updateValue(event) {
  
    this.setState({
      selectedLocation: event.target.value
    })
  }

  onSubmit(event) {
      event.preventDefault();
      var that = this;

      var userLocation = Object.assign({}, that.state.userLocation)
      userLocation["locationId"] = that.state.selectedLocation.registerLocationId;

      this.props.actions.saveUserLocation(userLocation).then(function() {
        
        if(that.props.continue)
          that.props.continue()
        else
          that.props.history.replace('/');

      })
  }

  render() {
    return (
      <ProfileForm user={this.state.selectedLocation} registerLocations={this.props.registerLocations}
       onChange={this.updateValue} onSubmit={this.onSubmit} />
    )
  }

}


function mapStateToProps(state, ownProps) { 

  var userLocation = {
    userLocationId: 0,
    locationId: '',
    userId: '',
    postcode: ''
  }

  let selectedLocation = {}

  if (state.userLocation) {
    userLocation = state.userLocation;

    var values = state.registerLocations.filter(x => x.registerLocationId == userLocation.locationId);
    if(values.length > 0) {
      selectedLocation = values[0]
    }
  }


  return {
    registerLocations: state.registerLocations,
    selectedLocation: selectedLocation,
    userLocation: userLocation
  }
}

function mapDispatchToProps(dispatch) {
  return {
      actions: bindActionCreators(adminActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);

